import { mergeClasses } from "@fluentui/react-components";
import { IDashboardHeaderProps } from "./DashboardHeader.types";
import { useStyles } from "./DashboardHeader.styles";

export const DashboardHeader = ({
  isCollapsed,
}: IDashboardHeaderProps): JSX.Element => {
  const styles = useStyles();
  return (
    <header className={styles.header}>
      <h1 className={styles.title}>Engineering Analytics</h1>
      <p
        className={mergeClasses(
          styles.subtitle,
          isCollapsed && styles.subtitleCollapsed,
        )}
        aria-hidden={isCollapsed}
      >
        Unified view of delivery metrics from Azure DevOps. Tracks velocity,
        quality, and delivery health across all engineering teams.
      </p>
    </header>
  );
};
